import PropTypes from 'prop-types'
import { cn } from '../../_utils/cn'
import { menuVariants } from '../variants/Menu.variants'

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export const MenuColumn = ({ className, children }) => {
  return <div className={cn(menuVariants.column(), className)}>{children}</div>
}

MenuColumn.displayName = 'MenuColumn'

MenuColumn.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}
